import { Controller } from "@hotwired/stimulus"
import { AreaSeries, LineSeries, createChart } from "lightweight-charts"

const BRAND = {
  yellow: "#EAB308",
  dark: "#171717",
  white: "#FAFAFA",
}

const COLORS = {
  chartBackground: BRAND.white,
  text: BRAND.dark,
  grid: "rgba(23, 23, 23, 0.08)",
  border: "rgba(23, 23, 23, 0.18)",
  crosshairLine: "rgba(234, 179, 8, 0.55)",

  costLine: "rgb(59, 130, 246)",
  priceLine: "rgb(34, 197, 94)",
  profitLine: "rgb(249, 115, 22)",
}

export default class extends Controller {
  static targets = ["container"]
  static values = {
    cost: Array,
    price: Array,
    profit: Array,
  }

  connect() {
    if (!document.getElementById("hide-tv-attr-logo")) {
      const style = document.createElement("style")
      style.id = "hide-tv-attr-logo"
      style.textContent = "#tv-attr-logo { display: none !important; }"
      document.head.appendChild(style)
    }
    if (!this.hasContainerTarget) return

    const cost = Array.isArray(this.costValue) ? this.costValue : []
    const price = Array.isArray(this.priceValue) ? this.priceValue : []
    const profit = Array.isArray(this.profitValue) ? this.profitValue : []

    this.chart = createChart(this.containerTarget, {
      autoSize: true,
      layout: {
        background: { type: "solid", color: COLORS.chartBackground },
        textColor: COLORS.text,
      },
      grid: {
        vertLines: { color: COLORS.grid },
        horzLines: { color: COLORS.grid },
      },
      rightPriceScale: {
        borderColor: COLORS.border,
        textColor: COLORS.text,
        scaleMargins: { top: 0.12, bottom: 0.18 },
      },
      timeScale: { borderColor: COLORS.border },
      crosshair: {
        vertLine: { color: COLORS.crosshairLine },
        horzLine: { color: COLORS.crosshairLine },
      },
    })

    const currencyFormat = {
      type: "custom",
      minMove: 0.001,
      formatter: (p) => `$${Number(p).toFixed(3)}`,
    }

    // Fill cost to match the “filled” pattern used in the newer charts.
    this.costSeries = this.chart.addSeries(AreaSeries, {
      lineColor: COLORS.costLine,
      topColor: "rgba(59, 130, 246, 0.22)",
      bottomColor: "rgba(59, 130, 246, 0.02)",
      lineWidth: 2,
      priceLineVisible: false,
      crosshairMarkerVisible: true,
      crosshairMarkerRadius: 4,
      crosshairMarkerBackgroundColor: "#FFFFFF",
      crosshairMarkerBorderColor: COLORS.costLine,
      priceFormat: currencyFormat,
    })

    this.priceSeries = this.chart.addSeries(LineSeries, {
      color: COLORS.priceLine,
      lineWidth: 2,
      priceLineVisible: false,
      crosshairMarkerVisible: true,
      crosshairMarkerRadius: 4,
      crosshairMarkerBackgroundColor: COLORS.priceLine,
      crosshairMarkerBorderColor: COLORS.priceLine,
      priceFormat: currencyFormat,
    })

    this.profitSeries = this.chart.addSeries(LineSeries, {
      color: COLORS.profitLine,
      lineWidth: 2,
      priceLineVisible: false,
      crosshairMarkerVisible: true,
      crosshairMarkerRadius: 4,
      crosshairMarkerBackgroundColor: COLORS.profitLine,
      crosshairMarkerBorderColor: COLORS.profitLine,
      priceFormat: currencyFormat,
    })

    this.costSeries.setData(cost)
    this.priceSeries.setData(price)
    this.profitSeries.setData(profit)

    requestAnimationFrame(() => {
      if (this.chart) this.chart.timeScale().fitContent()
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.remove()
      this.chart = null
    }
  }
}


